"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMapmakerSvgContext = exports.MapmakerSvgContextProvider = void 0;
const react_1 = require("react");
const MapmakerSvgContext = (0, react_1.createContext)({
    svgScale: 1,
    businessId: null,
});
exports.MapmakerSvgContextProvider = MapmakerSvgContext.Provider;
function useMapmakerSvgContext() {
    return (0, react_1.useContext)(MapmakerSvgContext);
}
exports.useMapmakerSvgContext = useMapmakerSvgContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJTdmdDb250ZXh0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbXBvbmVudHMvTWFwbWFrZXJTdmdDb250ZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxpQ0FBa0Q7QUFRbEQsTUFBTSxrQkFBa0IsR0FBRyxJQUFBLHFCQUFhLEVBQTBCO0lBQ2hFLFFBQVEsRUFBRSxDQUFDO0lBQ1gsVUFBVSxFQUFFLElBQUk7Q0FDakIsQ0FBQyxDQUFDO0FBRVUsUUFBQSwwQkFBMEIsR0FBRyxrQkFBa0IsQ0FBQyxRQUFRLENBQUM7QUFFdEUsU0FBZ0IscUJBQXFCO0lBQ25DLE9BQU8sSUFBQSxrQkFBVSxFQUFDLGtCQUFrQixDQUFDLENBQUM7QUFDeEMsQ0FBQztBQUZELHNEQUVDIn0=